.sidebar {
  width: 56px;
  height: 100%;
  background: var(--kh-surface);
  border-right: 1px solid var(--kh-border);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 0;
  gap: 8px;
  flex: 0 0 auto;
}

.button {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: none;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--kh-text-secondary);
  transition:
    background var(--kh-duration-fast) var(--kh-ease-out),
    color var(--kh-duration-fast) var(--kh-ease-out);
}

.button:hover {
  background: var(--kh-off-white);
  color: var(--kh-text-primary);
}

.buttonActive {
  background: var(--kh-red-dim);
  color: var(--kh-red);
}
